import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/anunciante-estabelecimento",

        async updateAdvertisersEstablishment({
            advertiserId,
            establishmentId,
            data,
        }) {
            const url = this.url(
                `/${advertiserId}/limite-acesso/${establishmentId}`
            );
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, data).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async listAdvertisers(establishmentId) {
            const url = this.url(`/${establishmentId}`);
            return await Vue.http.get(url);
        },

        parseAdvertiserEstablishment(data) {
            let configSelecaoAutomaticaCampanha = {};
            configSelecaoAutomaticaCampanha.selecaoAutomaticaCampanha =
                data.establishment.selecaoAutomaticaCampanha || true;
            configSelecaoAutomaticaCampanha.anunciantesVeiculacao =
                data.autoCampaigns;
            return configSelecaoAutomaticaCampanha;
        },
    },
    base
);
